var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "condition-node-config" },
    [
      _c("el-form", { attrs: { "label-width": "100px" } }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "row-label" }, [_vm._v("条件名称")]),
            _c("el-input", {
              attrs: {
                size: "small",
                placeholder: "请输入",
                maxlength: "24",
                "show-word-limit": "",
              },
              model: {
                value: _vm.selectedNode.name,
                callback: function ($$v) {
                  _vm.$set(_vm.selectedNode, "name", $$v)
                },
                expression: "selectedNode.name",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "row-label" }, [_vm._v("优先级")]),
            _c(
              "el-popover",
              {
                attrs: {
                  placement: "right",
                  width: "250",
                  trigger: "click",
                  "popper-class": "popover-leave",
                },
              },
              [
                _c("div", { staticClass: "popover-leave-title" }, [
                  _vm._v("拖拽条件调整优先级顺序"),
                ]),
                _c(
                  "draggable",
                  {
                    staticStyle: { width: "100%", "min-height": "25px" },
                    attrs: {
                      list: _vm.prioritySortList.slice(0, -1),
                      group: "from",
                      options: _vm.sortOption,
                    },
                  },
                  _vm._l(
                    _vm.prioritySortList.slice(0, -1),
                    function (cd, index) {
                      return _c(
                        "div",
                        {
                          class: {
                            "drag-no-choose": true,
                            "drag-hover": cd.id === _vm.selectedNode.id,
                          },
                        },
                        [
                          _c("ellipsis", {
                            staticClass: "name",
                            staticStyle: { width: "160px" },
                            attrs: { "hover-tip": "", content: cd.name },
                          }),
                          _c("div", { staticClass: "level" }, [
                            _vm._v("优先级 " + _vm._s(index + 1)),
                          ]),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _c(
                  "draggable",
                  {
                    staticStyle: { width: "100%", "min-height": "25px" },
                    attrs: {
                      list: _vm.prioritySortList.slice(-1),
                      group: "from",
                      options: _vm.sortOption,
                      disabled: true,
                    },
                  },
                  _vm._l(_vm.prioritySortList.slice(-1), function (cd, index) {
                    return _c(
                      "div",
                      {
                        class: {
                          "drag-no-choose": true,
                          "drag-hover": cd.id === _vm.selectedNode.id,
                          "no-drag": true,
                        },
                      },
                      [
                        _c("ellipsis", {
                          staticClass: "name",
                          staticStyle: { width: "160px" },
                          attrs: { content: cd.name },
                        }),
                        _c("div", { staticClass: "level" }, [
                          _vm._v(
                            "优先级 " + _vm._s(_vm.prioritySortList.length)
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn-leave",
                    attrs: {
                      slot: "reference",
                      icon: "el-icon-sort",
                      size: "small",
                    },
                    slot: "reference",
                  },
                  [_vm._v("优先级" + _vm._s(_vm.nowNodeLeave + 1))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("group-item"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }